import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import GoogleLogin, { GoogleLogout } from 'react-google-login';
import Home from './Home';
import { useParams, useNavigate, useRouteMatch } from "react-router-dom";
import swal from 'sweetalert';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { saveUsers } from "../utilities/common"
import { logoutClear } from "../utilities/common"


export default function Login() {

    let navigate = useNavigate();
    let { name } = useParams();

    let urlParam = JSON.parse(localStorage?.getItem('urlParam'))
    console.log(urlParam)


    const [usersList, setUsersList] = useState([])

    useEffect(() => {

        axios.get('https://xbw2vzb3jb.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-User-Node18')
            .then((res) => setUsersList(res.data.Items))
            .catch(err => console.log(err))

    }, [])


    const responseGoogle = (response) => {
        console.log(response)
        if (response?.profileObj?.email?.indexOf('@mpp.co.in') > -1) {
            let data = {
                id: uuidv4(),
                email: response?.profileObj?.email,
                name: response?.profileObj?.givenName
            }

            let userData = usersList.filter(e => e?.email === data?.email)

            console.log("userData---->", userData, "data------->", data, "user List------->", usersList)

            if (urlParam?.length > 1) {
                navigate(`/event/${urlParam[5]}/${urlParam[6]}/${urlParam[7]}`);
            } else {
                navigate("/home", { state: response });
            }

            if (userData.length > 0) {

            } else {
                axios.post('https://xbw2vzb3jb.execute-api.ap-south-1.amazonaws.com/default/Mathrubhumi-LiveBlog-User-Node18', data)
                    .then(() => { })
                    .catch((err) => console.log(err))
            }

            // navigate("/home", { state: response });
            // localStorage.setItem('user', JSON.stringify(response));
            saveUsers(response)
            console.log("iam here !!!!")


        } else {
            navigate("/");
            logoutClear()
            if (response?.profileObj?.email) {
                swal({
                    title: "OOPS !!!",
                    text: "Incorrect email, Please try again",
                    icon: "error",
                });
            }
        }

    }



    return (
        <div className="l-login-bg">
            <div className="d-flex align-items-center justify-content-center l-login">
                <div class="card l-login-card">
                    <div class="card-body text-center py-4">
                        <h4>Mathrubhumi <span className="fw-bold " style={{ color: "#d80000" }}>LiveBlog<span className="l-blink_me">.</span></span></h4>

                        <div className="my-4 d-flex justify-content-center">

                            <GoogleLogin
                                //clientId="506836883990-i1rhssrktfn1bdqcqg0gsbj8f96c5p1r.apps.googleusercontent.com"
                                clientId="157397223184-jce5rbonrisqg52661qmna3b2n2dtb7f.apps.googleusercontent.com"
                                buttonText="Login"
                                onSuccess={responseGoogle}
                                onFailure={responseGoogle}
                                redirectUri="https://apps.mathrubhumi.com/testliveBlog/index.html#/home"
                                cookiePolicy={'single_host_origin'}
                                isSignedIn={true}
                                ux_mode={'redirect'}
                                render={renderProps => (
                                    <button type="button" class="btn btn-light d-flex" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                        <img style={{ width: "25px" }} className="img-fluid mx-3" src="https://images.mathrubhumi.com/liveBlog23/icons-google.png"></img>
                                        Sign in with Google</button>
                                )}
                                
                            />
                        </div>
                        <p className="m-0 py-2" style={{ fontSize: "12px", color: "gray" }}>നിങ്ങളുടെ ജിമെയിൽ അക്കൗണ്ട്‌ ഉപയോഗിച്ച്‌ ലോഗിൻ ചെയ്യുക.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
